// New page links start at the top; history and anchors retain Gatsby's behavior.
function shouldScrollToTop({ previous, location, historyNavigation }) {
  return Boolean(
    previous &&
    !historyNavigation &&
    !location.hash &&
    (previous.pathname !== location.pathname ||
      previous.search !== location.search),
  );
}
module.exports = { shouldScrollToTop };
